import { Component } from '@angular/core';
import { ViewController, Events, NavParams } from 'ionic-angular';

@Component({
  selector: 'calendar-datepicker-popover',
  templateUrl: 'calendar-datepicker.html'
})


export class CalendarDatePickerPopover {

  datum: any;
  element: any;

  constructor(
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public events: Events) {
  }

  ionViewDidLoad() {
    this.element = this.navParams.get('element');
    this.datum = this.navParams.get('date');
  }

  setDateValue(val) {
    this.datum = val;
  }

  finish() {
    this.events.publish('inputs:datepickerset', this.datum, this.element);
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/popovers/date-picker/calendar-datepicker.ts